import React, {ChangeEvent, useRef, useState} from 'react'
import { useHistory } from 'react-router';

import {
    Page,
    Container
} from "./ForgotPassword.styles";
import {Button} from "@material-ui/core";
import MaterialInput from "../../../components/Inputs/MaterialInput";
import {exitReact} from "../../../utils";
import SignUpHeader from "../../../components/SignUpHeader";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import { openMailtoUrl } from "../../../utils/mailto";

// @ts-ignore
const TempStars = window.TempStars;
// @ts-ignore
const app = window.app;

interface ErrorProps {
    email?: string;
    password?: string;
    terms?: string;
}

export default function ForgotPassword() {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState<ErrorProps>({});
    const [passwordReset, setPasswordReset] = useState<boolean>(false);


    const onSubmit = async (event: any) => {
        event.preventDefault();
        const {email} = event.target
        
        // Clear previous errors on new submission
        setErrorMessage({});

        if (!email.value.length) {
            return setErrorMessage({ email: 'Email cannot be empty' });
        }

        try {
            app.showPreloader('Sending Password Reset');
            await TempStars.Api.requestPasswordReset( email.value )
            setPasswordReset(true);
            app.hidePreloader();
        } catch (e: any) {
            TempStars.Analytics.track('Password Reset - error')
            setPasswordReset(false);
            app.hidePreloader();
            const errorMsg = e?.error?.message || e?.message || e?.error || 'An error occurred. Please try again.';
            const userFriendlyMsg = errorMsg.toLowerCase().includes('no user') || 
                                   errorMsg.toLowerCase().includes('user not found') ||
                                   errorMsg.toLowerCase().includes('no account')
                ? 'No account found with this email address'
                : errorMsg;
            return setErrorMessage({ email: userFriendlyMsg });
        }
    }

    const onBack = () => {
        history.push({
            pathname: 'Login',
        })
    }

    const onContactSupport = (e: React.MouseEvent) => {
        e.preventDefault();
        const mailtoUrl = 'mailto:help@tempstars.com?subject=Forgotten%20Password';
        openMailtoUrl(mailtoUrl, { to: 'help@tempstars.com', subject: 'Forgotten Password' });
    }

    const handleEmailChange = () => {
        if (errorMessage?.email) {
            setErrorMessage({});
        }
        if (passwordReset) {
            setPasswordReset(false);
        }
    }

    return (
        <Page>
            <Container data-page="role-select" className={'no-swipeback'}>
                <HeaderStatusBar onButton={onBack} buttonText={'Back'} withArrow />

                <div className={"loginForm"}>
                    <SignUpHeader
                        title={'Forgot Password?'}
                        description={'Just enter your email and we\'ll send you a link to reset it.'}
                        error={errorMessage && (errorMessage?.email) && 'Please fix the errors below'}
                    />

                    {passwordReset && <div className="row">
                            <div id="forgot-password-status">
                                <div className={'resetedText'}>E-mail sent. Check the "Junk" folder in your e-mail if you don't see it in your Inbox.
                                </div>
                            </div>
                    </div>}

                    <div className="contentBlock">
                        <form id="login-form" onSubmit={onSubmit}>
                            <div>
                                <MaterialInput
                                    className={'inset'}
                                    label="Email"
                                    type="email"
                                    id={'email'}
                                    name={"email"}
                                    error={!!errorMessage?.email}
                                    helperText={!!errorMessage?.email && errorMessage.email}
                                    onChange={handleEmailChange}
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    id="signup-button"
                                    className="bigButtonInNewStyle"
                                    type={'submit'}
                                >
                                    Send Password Reset
                                </Button>
                            </div>
                        </form>
                    </div>
                    <div className="contactLink">
                        <a
                            href="mailto:help@tempstars.com?subject=Forgotten%20Password"
                            onClick={onContactSupport}
                            className="external footerMsg underlinedLink no-fastclick"
                            aria-label="Contact Support"
                            data-testid="forgot-password-contact-support-link"
                            content-desc="forgot-password-contact-support-link"
                        >
                            Contact Support
                        </a>
                    </div>
                </div>

                <div className="footer footerLinks"></div>
            </Container>
        </Page>
    )
}
